import { imageSizeCollection } from "@/firebase";

const state = {
  imageSize: {},
};

const getters = {};

const actions = {
  getImageSize({ commit }, payload) {
    imageSizeCollection
      .where("client", "==", payload)
      .orderBy("name", "asc")
      //.limit(10)
      .get()
      .then((querySnapshot) => {
        let tempData = [];
        querySnapshot.forEach((doc) => {
          tempData.push(Object.assign(doc.data(), { id: doc.id }));
        });
        commit("getImageSize", tempData);
      });
  },
  addImageSize({ commit }, payload) {
    imageSizeCollection.add(payload).then((docRef) => {
      commit("addImageSize", Object.assign(payload, { id: docRef.id }));
    });
  },
  removeImageSize({ commit }, payload) {
    imageSizeCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removeImageSize", payload);
      });
  },
  editImageSize({ commit }, payload) {
    imageSizeCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editImageSize", payload);
      });
  },
};

const mutations = {
  getImageSize(state, payload) {
    state.imageSize = payload;
    //console.log(state.imageSize);
  },
  addImageSize(state, payload) {
    state.imageSize.push(payload);
  },
  removeImageSize(state, payload) {
    const index = state.imageSize.findIndex((item) => item.id == payload);
    state.imageSize.splice(index, 1);
  },
  editImageSize(state, payload) {
    const index = state.imageSize.findIndex((item) => item.id == payload.id);
    state.imageSize.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
